export function scanedData (state, opened) {
  state.scaneddata = opened
}
